import React, { Component } from "react";
import Icon from "../icon";
import Modal from "src/modules/lodging/components/modal";
import Upselling from "./upselling";
import provisionalModuleDataBasedOnLanguage from "./provisionalModuleDataBasedOnLanguage";
import Link from "../link";

export default class UpsellingModal extends Component {
  moduleData = provisionalModuleDataBasedOnLanguage(this.props.language)

  render() {
    const { upselling, open, language, addedProductName, closeFn } = this.props;
    return (
      <Modal
        size="small"
        alignedCenter 
        closeFn={() => closeFn()}
        open={open}
        title={<Icon icon="CheckCircle" className="text-[#32ab0c]"/>}
        titleCentered
        footer={
          <Link
            href={this.moduleData.cartLink}
            className={`z-[1] py-2.5 px-4 flex justify-between items-center font-semibold text-sm rounded-3xl min-w-max w-full text-[color:var(--secondaryColor)] bg-[color:var(--primaryColor)]`}
          >
            <Icon icon="ArrowRight" className="invisible w-6" />
            <span>{this.moduleData.goToCart}</span>
            <Icon icon="ArrowRight" className="w-6"/>
          </Link>
        }
        >
        <div className="text-center flex flex-col text-sm mb-6">
          {
            Array.isArray(addedProductName) 
            ? 
              addedProductName.map((name, index) => {
                return <span key={`added_${index}`} className="font-bold">{name}</span>
              })
            :
              <span className="font-bold">{addedProductName}</span>
          }
          <span>{this.moduleData.addedToCart}</span>
        </div>
        <Upselling upselling={upselling} language={language} />
      </Modal>
    )
  }
}
